import { Button } from "@/components/ui/button";
import { PartyPopper, Rocket } from "lucide-react";

interface StepThreeProps {
  avatar: string;
  color: string;
  goal: string;
  onFinish: () => void;
}

export function StepThree({ avatar, color, goal, onFinish }: StepThreeProps) {
  return (
    <div className="space-y-6 text-center py-4">
      <div className="space-y-6">
        {/* Celebration animation */}
        <div className="flex justify-center items-center gap-4 text-6xl animate-bounce">
          <span>{avatar}</span>
          <PartyPopper className="w-12 h-12 text-[#F97316]" />
        </div>

        <div className="space-y-3">
          <h2 className="text-4xl font-bold bg-gradient-to-r from-[#F97316] to-[#D946EF] bg-clip-text text-transparent">
            You're All Set! 🎉
          </h2>
          <p className="text-xl text-muted-foreground">
            Time to start crushing your goals!
          </p>
        </div>

        {/* Summary card */}
        <div className="bg-gradient-to-br from-[#F97316]/10 to-[#D946EF]/10 rounded-2xl p-6 border-2 border-dashed border-[#9b87f5]">
          <div className="space-y-4">
            <div className="flex items-center justify-center gap-3">
              <span className="text-5xl">{avatar}</span>
              <div 
                className="w-8 h-8 rounded-full border-4 border-white shadow-lg"
                style={{ backgroundColor: color }}
              />
            </div>
            {goal !== "I'll Create My Own" && (
              <div className="space-y-1">
                <p className="text-sm text-muted-foreground">Your first goal:</p>
                <p className="text-lg font-semibold">{goal}</p>
              </div>
            )}
          </div>
        </div>

        <div className="space-y-2">
          <p className="text-lg font-semibold">Here's what you can do:</p>
          <ul className="text-left space-y-2 max-w-md mx-auto">
            <li className="flex items-center gap-2">
              <span className="text-2xl">✅</span>
              <span>Create goals and break them into small steps</span>
            </li>
            <li className="flex items-center gap-2">
              <span className="text-2xl">📊</span>
              <span>Track your progress and earn points</span>
            </li>
            <li className="flex items-center gap-2">
              <span className="text-2xl">🏆</span>
              <span>Celebrate every win, big or small</span>
            </li>
          </ul>
        </div>
      </div>

      <Button 
        type="button"
        size="lg" 
        className="w-full text-lg bg-gradient-to-r from-[#F97316] to-[#D946EF] hover:opacity-90 h-14"
        onClick={onFinish}
      >
        <Rocket className="w-5 h-5 mr-2" />
        Let's Start My Journey!
      </Button>
    </div>
  );
}
